import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastMessage {
  message: string;
  params?: any;
  timestamp: number;
  type: 'success' | 'error' | 'warning';
}

@Injectable({
  providedIn: 'root',
})
export class ToastrService {

  private readonly messagesSubject = new BehaviorSubject<ToastMessage[]>([]);
  public readonly messages$ = this.messagesSubject.asObservable();

  constructor(
    private translateService: TranslateService,
    private snackBar: MatSnackBar,
  ) {}

  public notice(
    message: string,
    params?: any,
    duration: number = 3000,
    type: 'success' | 'error' | 'warning' = 'success',
  ) {
    const msg = this.translateService.instant(message, params);   
    this.snackBar.open(msg, '', { duration: duration, verticalPosition: 'top', panelClass: [type] });

    // aggiorna la lista
    const newItem: ToastMessage = {
      message,
      params,
      type,
      timestamp: Date.now(),
    };

    this.messagesSubject.next([
      ...this.messagesSubject.value,
      newItem,
    ]);    
  }

  clear() {
    this.messagesSubject.next([]);
  }
}
